import React, {Component, Fragment} from 'react'
import cn from 'classnames'
import FormGroup from './FormGroup'
import Label from './Label'
import Input from './Input'


class RenderPasswordFormGroup extends Component {
    state = {
        showPassword : false
    }

    render() {

        return (
            <FormGroup {...this.props} className = "js-show-hide-password">
                {
                    this.renderLabelInput()
                }
            </FormGroup>
        )
    }

    renderLabelInput = () => {
        let {label} = this.props
        const {showPassword} = this.state

        return (
            <Fragment>
                <Label {...this.props}>
                    {
                        label
                    }
                </Label>
                <Input {...this.props} type = {showPassword ? "text" : "password"} />
                <span onClick={this.handleShowPassword} className={cn("js-show-hide-trigger", {
                    "js-show-hide-trigger__show" : showPassword,
                })}></span>
            </Fragment>
        )
    }

    handleShowPassword = () => {
        this.setState({showPassword : !this.state.showPassword})
    }
}

export default RenderPasswordFormGroup


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/RenderPasswordFormGroup.js